import { useLocation } from 'react-router-dom';
import { ROUTES_DATA } from '../utils/Constants';

export function useShouldDisableRedirect() {
    const location = useLocation();
    const { pathname } = location;
    const routesNotAllowingRedirect = ROUTES_DATA?.filter(
        (rd) => typeof rd.allowRedirect !== 'undefined' && !rd.allowRedirect
    )?.map((rd) => rd.path);
    return !!routesNotAllowingRedirect?.find((rwm) => rwm === pathname);
}
